import React from 'react';

import { StyledLink } from '../embed.styles';
import { EmbedCarouselPanel } from '../embed-carousel-panel';
import { useEmbedHomepageSections } from './use-embed-homepage-sections';

export function EmbedHomepageSections({ dispensary, menuSections }) {
  const {
    currentSection,
    handleMenuUrlChange,
    handleSectionSelect,
    hideTitle,
    hideViewAllLink,
    menuUrl,
    menuUrlInputError,
    script,
    sectionHasViewAllLink,
    setHideTitle,
    setHideViewAllLink,
  } = useEmbedHomepageSections({ dispensary, menuSections });

  return (
    <EmbedCarouselPanel
      title='Embed Homepage Sections'
      detail={
        <>
          Select a homepage section below to embed it on your website. <b>Note:</b> Only sections that have been created
          on your <StyledLink to={`dispensaries/${dispensary?.id}/customize/homepage`}>homepage</StyledLink> can be
          embedded.
        </>
      }
      selectFieldTitle='Section'
      selectFieldTestId='section-select'
      selectFieldValue={currentSection?.value}
      selectFieldOptions={menuSections}
      onSelectFieldChange={handleSectionSelect}
      hideTitle={hideTitle}
      onToggleHideTitle={() => setHideTitle(!hideTitle)}
      showHideViewAllLinkOption={sectionHasViewAllLink}
      hideViewAllLink={hideViewAllLink}
      onToggleHideViewAllLink={() => setHideViewAllLink(!hideViewAllLink)}
      menuUrlInputId='menu-url-input'
      menuUrl={menuUrl}
      onMenuUrlChange={handleMenuUrlChange}
      menuUrlInputError={menuUrlInputError}
      defaultMenuUrl={dispensary.menuUrl}
      script={script}
      scriptPlaceholderText='Add a valid menu URL above to generate the embed script!'
    />
  );
}
